import { AppConsts } from '../AppConsts'

export default function isGranted(permissionName) {
    return abp.auth.isGranted(permissionName);
}


// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/utils/abp.permission.js